import { render, staticRenderFns } from "./TuiTree.vue?vue&type=template&id=a689a6c6&"
import script from "./TuiTree.vue?vue&type=script&lang=ts&"
export * from "./TuiTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports